import { useCallback } from 'react'
import { useMarket } from '../contexts/MarketContext'
import { VARIANT_ID } from '../data/markets'
import { trackAddToCart } from '../utils/metaPixel'

const PRODUCT_NAME = 'El Gran Reto Creativo'

/**
 * Click handler shared by every purchase CTA: reports the Meta AddToCart event
 * with the exact amount and currency the visitor is seeing, then lets the link
 * continue to the Shopify cart.
 */
export function useAddToCart(): () => void {
  const { market } = useMarket()

  return useCallback(() => {
    trackAddToCart({
      value: market.priceAmount,
      currency: market.currency,
      contentId: VARIANT_ID,
      contentName: PRODUCT_NAME,
    })
  }, [market.priceAmount, market.currency])
}
